/**
 * @generated SignedSource<<13d339405129eb9b7b08d9fe707f094d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateRoomPropertyInput = {
  name: string;
};
export type RoomPropertiesListAddMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateRoomPropertyInput;
};
export type RoomPropertiesListAddMutation$data = {
  readonly createRoomProperty: {
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"RoomPropertiesListRow_roomProperty">;
    };
  };
};
export type RoomPropertiesListAddMutation = {
  response: RoomPropertiesListAddMutation$data;
  variables: RoomPropertiesListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoomPropertiesListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "RoomPropertyNode",
        "kind": "LinkedField",
        "name": "createRoomProperty",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RoomProperty",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RoomPropertiesListRow_roomProperty"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RoomPropertiesListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "RoomPropertyNode",
        "kind": "LinkedField",
        "name": "createRoomProperty",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RoomProperty",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "etgKey",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletable",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "RoomPropertyEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8e7d2c65bff70058c4620e217ac88fa0",
    "id": null,
    "metadata": {},
    "name": "RoomPropertiesListAddMutation",
    "operationKind": "mutation",
    "text": "mutation RoomPropertiesListAddMutation(\n  $input: CreateRoomPropertyInput!\n) {\n  createRoomProperty(input: $input) {\n    node {\n      ...RoomPropertiesListRow_roomProperty\n      id\n    }\n  }\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment RoomPropertiesListRow_roomProperty on RoomProperty {\n  id\n  icon\n  name\n  etgKey\n  ...EntityTableRow_entity\n}\n"
  }
};
})();

(node as any).hash = "7fced2d4acd143fefedb757c34c8a94e";

export default node;
